import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as types from "../../../constants/ComponentConstants";
import * as layoutActions from "../../../actions/e-loketLayoutActions";
import { validatieStatussenLoaded } from "../../../actions/validatieStatusActions";
import * as ajaxActions from "../../../actions/ajaxCounterActions";
import { throwException } from "../../../actions/exceptionActions";

import ToelatingenForm from "./ToelatingenForm";
import Section from "../../common/Section";
import redirector from "../../../util/redirector";
import ToelatingenPageHelper from "./ToelatingenPageHelper";
import EasterEggHandler from "../../common/EasterEggHandler";
import * as pageConstants from "../../../constants/EasterEggConstants";
import ScrollToFirstErrorComponent from "../../common/ScrollToFirstErrorComponent";
import { TochtRedenVanStatus } from "../../../constants/DomainConstants";

class ToelatingenPage extends ScrollToFirstErrorComponent {
    constructor(props, context) {
        super(props, context, true);

        this.filesHelper = null;
        this.state = {
            model: {
                toelatingen: []
            },
            errors: null,
            hasUnsavedChanges: false,
            fileComponents: {},
            disabled: false,
            scrollToTop: false,
            shouldScrollToFirstError: false
        };

        this.pageHelper = new ToelatingenPageHelper(this, redirector);
        this.testFiller = new EasterEggHandler(this, pageConstants.WIJZIG_TOELATINGEN);
    }

    componentDidMount = () => {
        const params = this.props.match.params;
        const modelId = params.modelId;

        if (this.props.shouldRedirect)
            redirector.goTo(`e-loket/organisator/${modelId}/false`);
        else {
            this.testFiller.bind();
            super.componentDidMount(); // better way to handle unsaved changes
            this.pageHelper.init();
        }
    };

    componentWillUnmount() {
        this.testFiller.unbind();
        this.state = {
            model: null
        };
    }
    componentDidUpdate = () => {
        super.componentDidUpdate();

        if (this.state.scrollToTop) {
            window.parent.scrollTo(0, 450);
            this.setState({
                scrollToTop: false
            });
        }
    };

    handleOnUploadFiles = (component, files) => this.filesHelper.uploadFiles(component, files);
    handleOnDeleteFile = (component, file) => this.filesHelper.deleteOneFile(component, file);
    handleOnSave = () => this.pageHelper.save();
    handleOnChange = (event, toelatingId) => this.pageHelper.change(event, toelatingId);
    handleOnGetError = (propertyName, toelatingId) => this.pageHelper.getErrorForProperty(propertyName, toelatingId);

    isReadyToRender = () => {
        return !!this.filesHelper;
    };

    render() {
        if (!this.isReadyToRender())
            return null;

        const state = this.state;
        const props = this.props;
        const models = state.model.toelatingen;
        const model = state.model;
        const disabled = props.disabled;
        const color = types.COLOR_GREEN;
        const downloadFileUrl = this.filesHelper.getFileDownloadUrl();
        const fileComponents = state.fileComponents;
        const bewijsstukkenFileTypes = props.bewijsstukkenFileTypes;
        const hasFinalStatus =
            model.redenVanStatus === TochtRedenVanStatus.DoorgestuurdTerGoedkeuring;

        return (
            <Section title={"Overzicht goedkeuringen van je tocht"} color={color}>
                <ToelatingenForm
                    models={models}
                    onChange={this.handleOnChange}
                    onSave={this.handleOnSave}
                    getError={this.handleOnGetError}
                    disabled={disabled}
                    onUploadFiles={this.handleOnUploadFiles}
                    onDeleteFile={this.handleOnDeleteFile}
                    downloadFileUrl={downloadFileUrl}
                    fileComponents={fileComponents}
                    color={color}
                    bewijsstukkenFileTypes={bewijsstukkenFileTypes}
                    validationMessageType={this.state.validationMessageType}
                    hasFinalStatus={hasFinalStatus}
                    doorANBGebiedGereden={model.doorANBGebiedGereden}
                    tochtMoetToelatingKrijgenVanAWV={model.tochtMoetToelatingKrijgenVanAWV}
                />
            </Section>);
    }
}

ToelatingenPage.propTypes = {
    loadLayout: PropTypes.func
};

function mapStateToProps(state) {
    const bewijsstukkenFileTypes = state.settings.fileTypes[types.FileComponentNames.BEWIJSSTUKKEN_TOELATING_];
    const disabled = state.settings.disabled;
    const shouldRedirect = !state.layout.topNavTabsSet;
	const svlDossierId = state.settings.svlDossierId;

    return {
        bewijsstukkenFileTypes: bewijsstukkenFileTypes,
        disabled: disabled,
        shouldRedirect: shouldRedirect,
		svlDossierId: svlDossierId
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        loadLayout: bindActionCreators(layoutActions.loadToelatingenLayout, dispatch),
        validatieStatussenLoaded: bindActionCreators(validatieStatussenLoaded, dispatch),
        ajaxActions: bindActionCreators(ajaxActions, dispatch),
        throwException: bindActionCreators(throwException, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ToelatingenPage);
